/**
 * Works out the media mime type from a file extension. Older recordings are named
 * like "clip.webm; codecs=vp9", so the codec suffix is dropped before matching.
 */
export function getMediaMimeType(fileName: string | undefined): string {
    if (!fileName) return 'unknown';
    const ext = fileName.split('.').pop()?.split(';')[0].trim().toLowerCase();
    const photoExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExts = ['mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'webm', 'mpeg'];

    if (ext && photoExts.includes(ext)) return `image/${ext}`;
    if (ext && videoExts.includes(ext)) return `video/${ext}`;
    return 'unknown';
}

export function isMediaType(fileName: string | undefined): 'photo' | 'video' | 'unknown' {
    const mimeType = getMediaMimeType(fileName);
    if (mimeType.startsWith('image/')) return 'photo';
    if (mimeType.startsWith('video/')) return 'video';
    return 'unknown';
}
